export default {
  VIDEO: 1,
  MUSICA: 2,
  CURSOS: 3,
  LEITURA: 4,
  ESCRITORIO: 7,
};
